export type ChamberRotationHintMode = 'scoutDisplayRoll' | 'guideRoll';

export interface ChamberRotationHintRow {
  key: ChamberRotationHintMode;
  command: string;
  label: string;
  active: boolean;
}

export const CHAMBER_ROTATION_HINT_TIMEOUT_MS = 900;

export function getChamberRotationHintRows(
  activeMode: ChamberRotationHintMode,
): ChamberRotationHintRow[] {
  return [
    {
      key: 'scoutDisplayRoll',
      command: 'Rotate',
      label: 'Scout image rotate',
      active: activeMode === 'scoutDisplayRoll',
    },
    {
      key: 'guideRoll',
      command: 'Ctrl + Rotate',
      label: 'Guide rotate',
      active: activeMode === 'guideRoll',
    },
  ];
}
